import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './Header.css'

import HomeLogo from '../components/HomeLogo'
import AboutLogo from '../components/AboutLogo'
import ContactLogo from '../components/ContactLogo'

class Header extends Component {
  constructor (props) {
    super(props)

    this.state = {
      home: false,
      about: false,
      contact: false
    }
  }

  show (name) {
    let obj = {}
    obj[name] = true
    this.setState(obj)
  }

  hide (name) {
    let obj = {}
    obj[name] = false
    this.setState(obj)
  }

  render () {
    return (
      <div className='header columns' style={{
        background: `${this.props.backgroundColor}`,
        borderBottomColor: `${this.props.textColor}`
      }}>
        <div className='column columns'>
          <div className='name' onMouseOver={() => this.show('home')} onMouseLeave={() => this.hide('home')}>
            <Link to='/' style={{ color: `${this.props.textColor}` }}>
              <div className='text'>ERWAN</div>
              <div className='text'>COUTELLIER</div>
            </Link>
          </div>
          <div className='logo'>
            {(this.state.home) ? <HomeLogo color={this.props.textColor} /> : ''}
          </div>
        </div>
        <div className='column columns spaceBox'>
          <div className='circle circleLeft' style={{ borderColor: `${this.props.textColor}` }} />
          <div className='circle circleRight' style={{ borderColor: `${this.props.textColor}` }} />
        </div>
        <div className='column columns rightContent'>
          <div className='logo'>
            {(this.state.about) ? <AboutLogo color={this.props.textColor} /> : ''}
            {(this.state.contact) ? <ContactLogo color={this.props.textColor} /> : ''}
          </div>
          <div className='name'>
            <Link to='/about' style={{ color: `${this.props.textColor}` }}><div id='infos' className='text rightText' onMouseOver={() => this.show('about')} onMouseLeave={() => this.hide('about')}>ABOUT</div></Link>
            <Link to='/contact' style={{ color: `${this.props.textColor}` }}><div id='contact' className='text rightText' onMouseOver={() => this.show('contact')} onMouseLeave={() => this.hide('contact')}>CONTACT</div></Link>
          </div>
        </div>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js